import { z } from 'zod';
/**
 * `GET /api/banner` + `PUT /api/banner` — the admin-edited sidebar banner.
 * Gate `banner:update` on both. The PUBLIC render shape rides the anonymous
 * `GET /api/status` (`banner` field) — admins read this richer state only to
 * prefill the edit form (it exposes the saved content even while disabled,
 * which `/api/status` cannot).
 */
/** Fixed semantic palette — single source for API validation + the UI CVA. */
export const bannerColorSchema = z.enum(['info', 'warning', 'success', 'error', 'neutral']);
/**
 * Rendered shape — only ever present for a real, enabled banner, so `title`
 * is required non-empty. Used by `getStatusResponseSchema.banner`.
 */
export const bannerContentSchema = z
    .object({
    title: z.string().min(1).max(120),
    description: z.string().max(280),
    color: bannerColorSchema,
})
    .strict();
/**
 * Editable shape — the `GET /api/banner` response AND the `PUT /api/banner`
 * body. Drafting while off allows an empty title; you cannot ENABLE an empty
 * banner (superRefine). `title` is trimmed for the emptiness check only — the
 * stored value is the raw string.
 */
export const bannerStateSchema = z
    .object({
    enabled: z.boolean(),
    title: z.string().max(120),
    description: z.string().max(280),
    color: bannerColorSchema,
})
    .strict()
    .superRefine((val, ctx) => {
    if (val.enabled && val.title.trim().length === 0) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['title'],
            message: 'Title is required to enable the banner.',
        });
    }
});
//# sourceMappingURL=banner.js.map